import AbstractPageBaseController from '../../../core/abstracts/controllers/page-controller';

export default class ContactsImportPageController extends AbstractPageBaseController {
    constructor($scope, $injector) {
        super($scope, $injector);

        this.locale = this.injector.get('locale');
        this.alert = this.injector.get('Alert');
        this.state = this.injector.get('$state');

        const store = this.injector.get('Contacts');

        store.dispatch('getDefinitions')
            .then(() => {
                this.fields = _.keyBy(store.state.columns, 'key');
                this.scope.$applyAsync();
            });

    }

    onSuccess() {
        this.state.go('app.contacts.index');
    }

    onFailure(response) {
        this.alert.error(this.locale.getString('sweetalerts.import_unsuccessful_title'), response.message);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/contacts/controllers/pages/import.js